
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { mapState } from 'vuex'
import tabs from '@/views/dashboard/config/drawerTabs'
import { Drawer } from '@/views/interfaces/vuetify/drawer.interface'
import { Item } from '@/views/interfaces/vuetify/item.interface'

@Component({
  computed: {
    ...mapState({
      barColor: (state: any) => state.bar.barColor,
      barImage: (state: any) => state.bar.barImage,
    }),
  },
})
export default class DashboardCoreDrawer extends Vue {
  @Prop({ type: Boolean, default: false }) private readonly expandOnHover!: boolean

  private items: Drawer[] = tabs()

  get drawer(): boolean {
    return this.$store.state.drawer.visible
  }

  set drawer(val: boolean) {
    this.$store.commit('SET_DRAWER', val)
  }

  get computedItems(): any[] {
    return this.items.map(this.mapItem)
  }

  get profile(): any {
    return {
      avatar: true,
      group: '',
      title: this.$store.state.user.username,
      children: [
        {
          href: '',
          title: this.$t('my-profile'),
        },
        {
          to: '',
          title: this.$t('edit-profile'),
        },
        {
          to: '',
          title: this.$t('settings'),
        },
      ],
    }
  }

  @Watch('$vuetify.breakpoint.smAndDown')
  private watchSmAndDown(val: any): void {
    this.$emit('update:expandOnHover', !val)
  }

  private mapItem(item: any): Item {
    return {
      ...item,
      children: item.children ? item.children.map(this.mapItem) : undefined,
      title: this.$t(item.title),
    }
  }
}
